import { render, staticRenderFns } from "./heim-icon.vue?vue&type=template&id=e4b80510&scoped=true&"
import script from "./heim-icon.vue?vue&type=script&lang=js&"
export * from "./heim-icon.vue?vue&type=script&lang=js&"
import style0 from "./heim-icon.vue?vue&type=style&index=0&id=e4b80510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b80510",
  null
  
)

component.options.__file = "heim-icon.vue"
export default component.exports